import React from "react";
import runPropActions from "Utils/runPropActions";
import config from "Config";
let createReactClass = require("create-react-class");

/*
 * Blueprint for a cartoLayer configuration
 * */
const cartoLayerSource = {
  sql_api_template: "https://louse.geodb.host:443/user/{user}",
  maps_api_template: "https://louse.geodb.host:443/user/{user}",
  user_name: config.cartodb_username, // Required
  extra_params: {
    // api_key: "1b92bcebb285b3f2dd27855cb4516951fe91f085"
  },
  type: "cartodb", // Required
  zIndex: 5,
  sublayers: [
    {
      sql: "",
      opacity: 0.9,
      cartocss: ""
    }
  ]
};

/*
 * Create a CartoDB Layer and add it to the provided map
 * */
const createCartoLayer = (map, sql, cartocss, interactivity = []) =>
  cartoLayerSource
    .tap(({ sublayers }) => {
      sublayers[0].sql = sql;
      sublayers[0].interactivity = interactivity.join(", ");
      sublayers[0].cartocss = cartocss;
    })
    .chain(
      layerSource =>
        new Promise((resolve, reject) =>
          cartodb
            .createLayer(map, layerSource)
            .addTo(map)
            .on("done", resolve)
            .on("error", reject)
        )
    );

/*
 * Component to Manage a CartoLayer on its wrapping Map Component
 */
const CartoLayer = createReactClass({
  getInitialState() {
    return {
      layer: null
    };
  },
  render() {
    return (
      <div>
        {this.state.layer && React.Children.count(this.props.children)
          ? React.Children.map(this.props.children, child =>
              child
                ? React.cloneElement(child, { layer: this.state.layer })
                : null
            )
          : null}
      </div>
    );
  },
  addLayer(props) {
    createCartoLayer(
      props.map,
      props.sql,
      props.cartocss,
      props.interactivity
    ).then(layer => {
      this.setState({ layer });
    });
  },
  propActions() {
    return {
      sql: {
        enter: newProps => this.addLayer(newProps),
        leave: "removeLayer",
        change: newProps => this.state.layer.getSubLayer(0).set(newProps)
      }
    };
  },
  componentDidMount() {
    this.runPropActions = runPropActions.bind(this);
    this.runPropActions({}, this.props, this.propActions());
  },
  componentWillReceiveProps(newProps) {
    this.runPropActions(this.props, newProps, this.propActions());
  },
  componentWillUnmount() {
    this.props.map.removeLayer(this.state.layer);
  }
});

export default CartoLayer;



// WEBPACK FOOTER //
// ./components/Map/CartoLayer.js